import { render, staticRenderFns } from "./DetailLockDrawWhite.vue?vue&type=template&id=0883ef43&scoped=true"
import script from "./DetailLockDrawWhite.vue?vue&type=script&lang=js"
export * from "./DetailLockDrawWhite.vue?vue&type=script&lang=js"
import style0 from "./DetailLockDrawWhite.vue?vue&type=style&index=0&id=0883ef43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0883ef43",
  null
  
)

export default component.exports